module.exports = __webpack_public_path__ + "img/kv-pen-rocket.e4603c67.png";